
































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DispensationMedicine as DispensationMedicineType } from '@/types/dispensation'
import InputGroup from '@/mixins/form/inputGroup'

export type DispensatinMedicineInputType = {
  isOnedose: boolean
  remain: number
  isSuggestion: boolean
  suggestionNote: string
}

export type DispensatinMedicineInputListType = {
  [id: number]: DispensatinMedicineInputType
}

type ShowMedicineDetailsModalStatus = { [id: number]: boolean }

@Component({
  components: {
    MedicineDetailsModal: () =>
      import('@/components/dispensationCheckTab/MedicineDetailsModal.vue'),
    NumberInput: () => import('@/components/common/inputs/NumberInput.vue'),
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue'),
    TextareaInput: () => import('@/components/common/inputs/TextareaInput.vue')
  }
})
export default class DispensationMedicine extends mixins(InputGroup) {
  @Prop(Array) medicines!: Array<DispensationMedicineType>
  @Prop(Object) inputs!: DispensatinMedicineInputListType

  showMedicineDetailsModal = this.medicines.reduce(
    (status, { id }) => Object.assign(status, { [id]: false }),
    {} as ShowMedicineDetailsModalStatus
  )

  syncInputValue<T extends keyof DispensatinMedicineInputType>(
    field: T,
    value: DispensatinMedicineInputType[T]
  ) {
    Object.keys(this.inputs).forEach(id => {
      if (this.medicines[0].id !== Number(id)) {
        this.inputs[Number(id)][field] = value
      }
    })
  }

  handleClickMedicineName(id: number) {
    this.showMedicineDetailsModal[id] = !this.showMedicineDetailsModal[id]
  }

  handleChangeIsOnedose(value: boolean) {
    this.syncInputValue('isOnedose', value)
  }

  handleChangeIsSuggestion(value: boolean) {
    this.syncInputValue('isSuggestion', value)
  }

  handleChangeSuggestionNote(value: string) {
    this.syncInputValue('suggestionNote', value)
  }
}
